/**
 * storeComputed.ts
 * App.vue の s_* computed プロパティを自動生成するヘルパー
 *
 * 使い方:
 *   ...storeComputed(['printMap', 'isKuiuchi', ...])
 *   → { s_printMap: { get() {...}, set(v) {...} }, ... }
 *
 *   ...storeComputedReadonly(['url', 'finishLineFire', ...])
 *   → { s_url() { return this.$store.state.url }, ... }
 */

/** Vue Options API の this（$store を持つ） */
interface VueInstance {
  $store: {
    state: Record<string, any>
  }
}

/**
 * Store state property をそのまま get/set する computed を生成
 */
export function storeComputed(keys: string[]): Record<string, { get(): any, set(value: any): void }> {
  const result: Record<string, { get(): any, set(value: any): void }> = {}
  for (const key of keys) {
    result[`s_${key}`] = {
      get(this: VueInstance) {
        return this.$store.state[key]
      },
      set(this: VueInstance, value: any) {
        this.$store.state[key] = value
      }
    }
  }
  return result
}

/**
 * Store state property を読み取り専用で返す computed を生成
 */
export function storeComputedReadonly(keys: string[]): Record<string, (this: VueInstance) => any> {
  const result: Record<string, (this: VueInstance) => any> = {}
  for (const key of keys) {
    result[`s_${key}`] = function (this: VueInstance) {
      return this.$store.state[key]
    }
  }
  return result
}
